export default __webpack_public_path__ + "static/media/Banner.8b5120ba.jpg";